module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-09.061c9537.png";